export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-label-1200-a49ac369eed8320c2e31e3e826d169ff.webp";